export default __webpack_public_path__ + "static/media/offer4.5fd5cb6e.jpg";